import { WithStyles, withStyles } from '@mui/styles';
import { ClientMessageRecord } from '@tassat/fred-definitions';

import { ApproveClientMessage } from './approveClientMessage';
import { muiStyles } from './styles';

export interface ApproveClientMessageProps extends WithStyles<typeof muiStyles> {
    selectedMessage: ClientMessageRecord;
    approveMessage: () => void;
    cancelConfirm: () => void;
    approvalError: string;
}

export default withStyles(muiStyles)(ApproveClientMessage);